import * as React from "react";
import * as ReactDOM from "react-dom";
import VinLookupComponentReact from "./VinLookupComponentReact";
import { ReactComponent } from "react-formio";
import settingsForm from "./VinLookup.settingsForm";

export default class VinLookupComponent extends ReactComponent {
  private root: any;
  private component: any;
  private dataValue: any;
  private updateValue: any;
  private id: string;
  private on: Function;
  private error: any;
  private reactInstance: VinLookupComponentReact;

  static schema(...extend) {
    const schema = ReactComponent.schema(
      {
        type: "vinLookup",
        key: "vinLookup",
        label: "VIN",
        placeholder: "VIN"
      },
      ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: "Vin Lookup",
      group: "advanced",
      icon: "car",
      weight: -10,
      schema: VinLookupComponent.schema()
    };
  }

  static editForm = settingsForm;

  focus() {
    if (this.reactInstance) {
      this.reactInstance.focus();
    }
  }

  init() {
    this.on("validationFinished", event => {
      if (this.reactInstance && this.reactInstance.setState) {
        this.reactInstance.setState({ isValid: !this.error });
      }
    });
  }

  attachReact(element) {
    return ReactDOM.render(<VinLookupComponentReact value={this.dataValue} component={this.component} form={this} onChange={this.updateValue} isValid={!this.error} />, element);
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
